const Services = () => import('@/modules/admin/services/index.vue');
const Service = () => import('@/modules/admin/services/service/index.vue');
const Category = () => import('@/modules/admin/services/Category.vue');
const Package = () => import('@/modules/admin/services/package/index.vue');
const UpdatePrices = () =>
  import('@/modules/admin/services/price-update/create-price-update/index.vue');
const ScheduledPriceUpdate = () =>
  import('@/modules/admin/services/price-update/view-price-update/index.vue');
const EditPriceUpdate = () =>
  import('@/modules/admin/services/price-update/create-price-update/index.vue');

export default [
  {
    path: 'services',
    name: 'admin-services',
    component: Services,
    meta: {
      featureFlag: 'admin-services',
    },
    children: [
      {
        path: 'new/:categoryId?',
        name: 'admin-service-new',
        component: Service,
      },
      {
        path: ':serviceId',
        name: 'admin-service',
        component: Service,
      },
      {
        path: 'category/new',
        name: 'admin-service-category-new',
        component: Category,
        props: {
          parentRouteName: 'admin-services',
        },
      },
      {
        path: 'category/:categoryId',
        name: 'admin-service-category',
        component: Category,
        props: {
          parentRouteName: 'admin-services',
        },
      },
      {
        path: 'package/new',
        name: 'admin-service-package-new',
        component: Package,
        props: {
          parentRouteName: 'admin-services',
        },
        meta: {
          unleash: 'ServicePackages',
        },
      },
      {
        path: 'package/:packageId',
        name: 'admin-service-package',
        component: Package,
        props: {
          parentRouteName: 'admin-services',
        },
        meta: {
          unleash: 'ServicePackages',
        },
      },
      {
        path: 'update-prices',
        name: 'admin-service-update-prices',
        component: UpdatePrices,
        props: {
          parentRouteName: 'admin-services',
        },
      },
      {
        path: 'scheduled-price-update',
        name: 'admin-service-scheduled-price-update',
        component: ScheduledPriceUpdate,
        props: {
          parentRouteName: 'admin-services',
        },
      },
      {
        path: 'edit-price-update',
        name: 'admin-service-edit-price-update',
        component: EditPriceUpdate,
        props: {
          parentRouteName: 'admin-services',
        },
      },
    ],
  },
];
